module.exports = __webpack_public_path__ + "551042872c9a8ce543074ba436482705.pdf";